<gs-generic-crud #crud (selectionChanged)="onSelectionChanged()" *ngIf="config" [configuration]="config"></gs-generic-crud>
